const PASS_UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;
const PASS_UUID_GLOBAL_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi;

function isUuid(value) {
    return PASS_UUID_RE.test(String(value || "").trim());
}

function pickPassKeyFromObject(value) {
    if (!value || typeof value !== "object") return "";

    const maybe =
        value.pass_uuid ||
        value.pass_id ||
        value.pass_key ||
        value.id ||
        value.pass?.id ||
        "";

    const text = String(maybe || "").trim();
    return isUuid(text) ? text.match(PASS_UUID_RE)?.[0] || "" : "";
}

export function parsePassInput(raw) {
    const input = String(raw || "").trim();
    if (!input) return "";

    // Direct UUID or BBP-prefixed UUID.
    const strippedPrefix = input.replace(/^bbp\s*[:|-]\s*/i, "").trim();
    if (isUuid(strippedPrefix) && strippedPrefix.match(PASS_UUID_RE)?.[0] === strippedPrefix) {
        return strippedPrefix;
    }

    // URL payload support, such as /pass?pass_uuid=... or ?pass_id=...
    try {
        const url = new URL(input);
        const fromUrl =
            url.searchParams.get("pass_uuid") ||
            url.searchParams.get("pass_id") ||
            url.searchParams.get("pass_key") ||
            url.searchParams.get("id") ||
            "";
        const parsedUrlPass = parsePassInput(fromUrl);
        if (parsedUrlPass) return parsedUrlPass;
    } catch {
        // Not a URL. Keep checking other payload shapes.
    }

    // JSON QR payload support. This prevents grabbing another UUID field by mistake.
    try {
        const parsed = JSON.parse(input);
        const fromObject = pickPassKeyFromObject(parsed);
        if (fromObject) return fromObject;
    } catch {
        // Scanner fields can sometimes contain two QR payloads smashed together.
    }

    // Fallback for scanner fields that accidentally contain old+new scans.
    // Choose the latest UUID in the field so a second scan replaces the old one.
    const matches = input.match(PASS_UUID_GLOBAL_RE) || [];
    return matches.length ? matches[matches.length - 1] : "";
}

export function makeRequestId(prefix = "scan") {
    const base = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    return `${prefix}_${base}`;
}

export function toQuery(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            query.set(key, value);
        }
    });
    const qs = query.toString();
    return qs ? `?${qs}` : "";
}

export function formatDateTime(value) {
    if (!value) return "—";
    try {
        return new Date(value).toLocaleString();
    } catch {
        return String(value);
    }
}
